import React, { useState, useEffect, Dispatch } from 'react'
import { Divider, Col, Row, Checkbox, Button } from 'antd'
import { getBPStatus } from '../../api/BPTable/BPTableMethods'
import { IBox, IDates } from "../interface/interface"
import "./inventory.css"
import { CheckboxChangeEvent } from 'antd/lib/checkbox'

const STATUS = ["ON_GOING", "PENDING", "TO_DO", "COMPLETE"]

const defaultBox: IBox = {
  ON_GOING: true,
  PENDING: true,
  COMPLETE: true,
  TO_DO: false,
}

const InventoryFilter = (props: {
  setCheckedBox: Dispatch<IBox>, checkedBox: IBox,
  setDates: Dispatch<IDates>, dates: IDates,
  setSlider: Dispatch<[number, number]>, slider: [number, number]
  setDateRange: Dispatch<{ start: Date | undefined, end: Date | undefined }>, dateRange: { start: Date | undefined, end: Date | undefined }
}) => {
  const { setCheckedBox, checkedBox, setDateRange } = props
  const [statusData, setStatusData] = useState<any>([])

  useEffect(() => {
    getStatusData()
  }, [])

  const getStatusData = async () => {
    const res = await getBPStatus()
    if (res !== "ERR_NETWORK") {
      setStatusData(res)
    }
  }

  const getColor = (type: string) => {
    switch (type) {
      case 'ON_GOING': return "on-going"
      case 'PENDING': return 'waiting'
      case 'COMPLETE': return 'completed'
      case 'TO_DO': return 'to-do'
      default: return 'waiting'
    }
  }

  const getStatus = (type: string) => {
    const found = statusData?.find((elem) => elem._id === type)
    if (found) return found.count
    else return 0
  }

  const ColoredDiv = (props: { type: string }) => (
    <div className={getColor(props.type) + "-dot status-number"}>{getStatus(props.type)}</div>
  )

  const statusText = (status: string) => {
    switch (status) {
      case 'ON_GOING': return "En cours"
      case 'PENDING': return 'En attente'
      case 'COMPLETE': return 'Terminé'
      case 'TO_DO': return 'A faire'
      default: return 'En attente'
    }
  }


  const handleCheckbox = (event: CheckboxChangeEvent) => {
    if (event?.target?.id) {
      setCheckedBox({
        ...checkedBox,
        [event.target.id]: event.target.checked,
      })
    }
  }

  const Status = () => (
    <> {
      STATUS.map((status, index) => (
        <Row key={index} className='status-div' gutter={16}>
          <Col xs={4} style={{ paddingTop: '0.2rem' }}><Checkbox checked={checkedBox[status]} id={status} key={status} onChange={(event) => handleCheckbox(event)} /></Col>
          <Col xs={14}>{statusText(status)}</Col>
          <Col style={{ width: "100%", marginBottom: "0.3rem" }} xs={6}><ColoredDiv type={status} /></Col>
        </Row>
      ))
    }
    </>
  )

  const handleResetFilter = () => {
    setCheckedBox(defaultBox)
    setDateRange({ start: undefined, end: undefined })
  }

  return (
    <>
      <div id='inventory-filter' className='card-filter'>
        <h2>
          Filtrer par
        </h2>
        <Divider />
        <h3 className='status-title'>
          Statut
        </h3>
        <Status />
        <Divider />
        <div className='reinit-button-div'>
          <Button onClick={() => handleResetFilter()} >
            Réinitialiser
          </Button>
        </div>
      </div>
    </>
  )
}

export default InventoryFilter